import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ImportAnnotationsBl } from '../../../importAnnotations.bl';
import { IImportAnnotationsStore } from '../../../importAnnotations.store';
import { ImportAnnotationsStep } from '../../../models/ImportAnnotationsSteps';
import { InformationStepModal } from './InformationStepModal';

export const InformationStepContainer = observer((): ReactElement => {
  const bl = useInjection(ImportAnnotationsBl.$);
  const store = useInjection(IImportAnnotationsStore.$);

  const handleHide = (): void => {
    bl.cancelImport();
  };

  const handleSubmit = async (): Promise<void> => {
    bl.goToSelectFileStep();
    return Promise.resolve();
  };

  const isCurrentStep = store.currentStep === ImportAnnotationsStep.Information;

  return (
    <InformationStepModal
      onHide={handleHide}
      onSubmit={handleSubmit}
      show={isCurrentStep}
    />
  );
});
